import {mapActions, mapState} from 'vuex'
import * as DictionaryConstants from '../../../../constants/DictionaryConstants'
import dateUtils from "../../../../common/utils/dateUtil";
import moment from 'moment'

export default {
  data () {
    return {
      state: false,
      activeName: 'first'
    }
  },
  computed: {
    ...mapState('consumingRecordsModule', ['consumedCouponInfo']),
    consumedCouponInfoList () {
      return this.consumedCouponInfo
    },
    consumptionSum () {
      return `消费记录 (${this.consumedCouponInfo.length})`
    }
  },
  methods: {
    ...mapActions('consumingRecordsModule', ['getConsumedCoupon', 'updateCouponRecord', 'updateCouponFalseRecord']),
    dateFormat (time) {
      // return dateUtils.dateFormatTime(time)
      return time ? moment(time).format('YYYY/MM/DD HH:mm') : ''
    },
    arrowDown (e) {
      this.updateCouponRecord(e)
    },
    arrowUp (e) {
      this.updateCouponFalseRecord(e)
    }
  },
  mounted: function () {
    this.getConsumedCoupon()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member-consuming-records/views/consumption-record.js